<template>
    <!-- 商务合作 -->
    <section class="cooperation">
       <div class="w-1200 h-full position-relative">
            <div class="cooperation-form">
            <el-form :model="formInline" ref="dataForm" label-width="75px" size="small" :rules="rules">
                <el-form-item label="称呼" prop="name">
                    <el-input v-model="formInline.name" placeholder="请填写您的称呼"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phoneNumber">
                    <el-input v-model="formInline.phoneNumber" placeholder="请填写您的联系电话"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="formInline.email" placeholder="请填写您的邮箱"></el-input>
                </el-form-item>
                <el-form-item label="企业名称" prop="enterpriseName">
                    <el-input v-model="formInline.enterpriseName" placeholder="请填写贵司企业名称"></el-input>
                </el-form-item>
                <el-form-item label="意向产品" prop="intendedProduct">
                    <el-select v-model="formInline.intendedProduct" placeholder="请选择意向产品" class="w-full">
                        <el-option v-for="item in productOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="留言" prop="content">
                    <el-input v-model="formInline.content" placeholder="请填写您的详细需求" resize="none" maxlength="200" show-word-limit type="textarea" :rows="3"></el-input>
                </el-form-item>
            </el-form>
             <div class="ta-c mt15">
                <span class="btn" @click="onSubmit">提交</span>
                <p class="tips">您留下的联系方式等信息，仅用于与您联系或帮助您解决问题</p>
            </div>
        </div>
       </div>
    </section>
</template>

<script>
import { elementFromVerify } from '@/filters/verify.js'
import apiList from '@/api/apiList'
export default {
  data () {
    return {
      formInline: {
        roleType: '5',
        name: '',
        phoneNumber: '',
        content: '',
        email: '',
        enterpriseName: '',
        intendedProduct: ''
      },
      productOptions: [],
      // 表单校验
      rules: {
        name: [{ required: true, message: '请填写您的称呼', trigger: 'blur' }],
        phoneNumber: [
          { required: true, message: '请填写您的联系电话', trigger: 'blur' },
          { validator: elementFromVerify.phoneValid, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请填写您的邮箱', trigger: 'blur' },
          { validator: elementFromVerify.emailValid, trigger: 'blur' }
        ],
        enterpriseName: [{ required: true, message: '请填写您的企业名称', trigger: 'blur' }],
        intendedProduct: [{ required: true, message: '请选择意向产品', trigger: 'change' }]
      }
    }
  },
  methods: {
    /**
       * @desc 获取下拉框的内容
       */
    getOptions () {
      apiList.getList({ type: 'business_cooperation_intended_products' }).then(res => {
        this.productOptions = res.data.data.ddicList
      })
    },
    onSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          apiList.cooperationInsert(this.formInline).then(res => {
            if (res) {
              this.$message({ message: res.data.msg, type: 'success' })
              this.$refs['dataForm'].resetFields()
            }
          })
        }
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/variable.scss";
    .cooperation{
        height: 600px;
        background: url(../assets/cooperation_bg.png) 100% no-repeat;
        background-position: center center;
        .el-form-item__label{
            font-size: 12px;
            color: #333;
        }
        .el-input__inner,.el-textarea__inner{
            background:rgba(255,255,255,1);
            border-radius:2px;
            border:1px solid rgba(204,204,204,0.5);
            font-family: "PingFang SC","PingFangSC-Medium","Microsoft YaHei","微软雅黑",Arial,sans-serif;
            font-size: 12px;
                &::placeholder {
                    color: #ccc;
                }

                &::-webkit-input-placeholder {
                    /* WebKit browsers 适配谷歌 */
                    color: #ccc;
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 适配火狐 */
                    color: #ccc;
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ 适配火狐 */
                    color: #ccc;
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10+  适配ie*/
                    color: #ccc;
                }
        }
        .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
            margin-bottom: 16px;
        }
        .cooperation-form{
            position: absolute;
            top: 75px;
            left: 150px;
            width: 400px;
            background:rgba(254,254,254,1);
            box-shadow:0px 2px 18px 12px rgba(49,131,255,0.06);
            border-radius:6px;
            padding: 35px 30px 25px 30px;
            font-size: 12px;
            .el-form{
                margin-right:10px;
            }
        }
        .btn {
            display: block;
            width:100px;
            height:32px;
            background:linear-gradient(137deg,rgba(44,124,255,1) 0%,rgba(70,160,255,1) 100%);
            border-radius:3px;
            cursor: pointer;
            font-size:14px;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:32px;
            margin: 0 auto;
        }
        .tips{
            font-size:12px;
            font-weight:400;
            color:rgba(153,153,153,1);
            margin-top: 10px;
        }
    }
</style>
